import get from 'lodash/get';

const WithErrorFields = {
  methods: {
    /**
     * Get error message for given field.
     * @return string
     */
    getErrorMessage(fieldName) {
      return this.errors.first(fieldName) || get(this.errorFields, fieldName, '');
    },

    resetErrorMessage(fieldName) {
      if (fieldName in this.errorFields) {
        delete this.errorFields[fieldName];
      }
    },
  },
  data() {
    return {
      errorFields: {},
    };
  },
};

export {WithErrorFields};
